<template lang="pug">
.robot-info.robot3s
  #info-b1
    .bg-mask(:class="{zoomIn: isB1Visible}")
    .ww
      .left
        .p1.delay3(:class="{fadeUp: isB1Visible}") 维拉3S&nbsp;&nbsp;&nbsp;&nbsp;科技与康养完美结合
        .p2.delay4(:class="{fadeUp: isB1Visible}") 首款面向健康养老的智慧康养服务机器人
        .p3.delay5(:class="{fadeUp: isB1Visible}") 安全看护  ｜  健康管理  ｜  精神陪护
      .right
        .p4.delay5(:class="{fadeUp: isB1Visible}")
          img.img(src="../../../assets/web/star.png") 
          span 上海市专精特新产品
        .p4.delay5(:class="{fadeUp: isB1Visible}")
          img.img(src="../../../assets/web/star.png") 
          span 上海市重大高端智能装备
        .p4.delay5(:class="{fadeUp: isB1Visible}")
          img.img(src="../../../assets/web/star.png") 
          span 上海市人工智能创新产品
  #info-b2 
    .ww
      .p1.delay1(:class="{fadeUp: isB2Visible}") 认识人&nbsp;/&nbsp;家
      .p2.delay2(:class="{fadeUp: isB2Visible}") 随叫随到  主动跟随服务 
      .p0.delay3(:class="{fadeUp: isB2Visible}") 如家人般  熟悉家中每一个角落
      .p3.deplay4(:class="{fadeUp: isB2Visible}") 人脸识别  ｜  自主建图  ｜  自主导航
      .p4
        .item.delay5(:class="{fadeDown: isB2Visible}")
          img(src="../../../assets/web/3s-info-1.png") 
          br 
          span 人脸识别
        .item.delay6(:class="{fadeDown: isB2Visible}")
          img(src="../../../assets/web/3s-info-2.png") 
          br 
          span 人体识别
        .item.delay7(:class="{fadeDown: isB2Visible}")
          img(src="../../../assets/web/3s-info-3.png") 
          br 
          span 步态识别

  #info-b3
    .ww
      .p1.delay1(:class="{fadeUp: isB3Visible}") 安全居家
      .p2.delay2(:class="{fadeUp: isB3Visible}") 机器人自主移动寻人 前往事发现场
      .p0.delay3(:class="{fadeUp: isB3Visible}") 视频通话联系家人紧急救援
      .p3.deplay4(:class="{fadeUp: isB3Visible}") 跌倒求助  ｜  语音呼救  ｜  安全监测
      .p4
        .item.delay5(:class="{fadeDown: isB3Visible}")
          img(src="../../../assets/web/3s-info-4.png") 
  #info-b4
    .ww
      .p1.delay1(:class="{fadeUp: isB4Visible}") 健康管理
      .p2.delay2(:class="{fadeUp: isB4Visible}") 机器人主动用药提醒  健康服务
      .p0.delay3(:class="{fadeUp: isB4Visible}") 智能导诊多轮对话  家庭全科医生
      .p3.deplay4(:class="{fadeUp: isB4Visible}") 用药提醒  ｜  智能导诊  ｜  健康百科 
  #info-b5
    .ww
      .p1.delay1(:class="{fadeUp: isB5Visible}") 精神陪伴
      .p2.delay2(:class="{fadeUp: isB5Visible}") 远程视频与家人亲情互动
      .p0.delay3(:class="{fadeUp: isB5Visible}")  陪伴闲聊 播放影音娱乐节目
      .p3.deplay4(:class="{fadeUp: isB5Visible}") 亲情关怀  ｜  日常闲聊  ｜  休闲娱乐 
</template>

<script>
import { isVisible } from '../../../common/utils'

export default {
  data () {
    return {
      robot3Show: DB.robot3Show,
      isB1Visible: true,
      isB2Visible: false,
      isB3Visible: false,
      isB4Visible: false,
      isB5Visible: false,
    }
  },
  computed: {},
  methods: {},
  created () {
    $(window).on('scroll', () => {
      this.isB1Visible = isVisible('#info-b1')
      this.isB2Visible = isVisible('#info-b2')
      this.isB3Visible = isVisible('#info-b3')
      this.isB4Visible = isVisible('#info-b4')
      this.isB5Visible = isVisible('#info-b5')
    })
  }
}
</script>

<style lang="stylus">
@import 'config'
.robot-info
  .ww
    position relative
    .p1
      font-size 37px
      color #181616
    .p0
      font-size 20px
      color #414141
    .p2
      font-size 20px
      color #414141
    .p3
      font-size 17px
      color #616161
  &.robot3s
    #info-b1
      position relative
      min-width 1200px
      height 800px
      overflow hidden
      .bg-mask
        position absolute
        top 0
        left 0
        width 100%
        height 100%
        background url('../../../assets/web/3s-info-b1.png') no-repeat center
        background-size auto 100%
      .ww
        display flex
        .left
          display flex
          flex-direction column
          text-align center
          margin-left 414px
          margin-top 135px
          .p2
            margin-top 37px
          .p3
            margin-top 34px
        .right
          display flex
          flex-direction column
          margin-top 75px
          margin-left 610px
          .p4
            font-size 17px
            display flex
            align-items center
            padding-bottom 13px
            img
              margin-right 10px
              width 15px
              height 15px
    #info-b2
      min-width 1200px
      background #f5f7f9
      height 800px
      background url('../../../assets/web/3s-info-b2.jpg') no-repeat 60% center
      background-size auto 100%
      .ww
        padding-top 118px
        margin-left 334px
        text-align left
        .p2
          margin-top 26px
        .p3
          margin-top 24px
        .p4
          margin-top 133px
          margin-left -228px
          .item
            vertical-align top
            display inline-block
            margin-right 32px
            text-align center
            img
              width 273px
              height 208px
            span 
              display inline-block
              font-size 26px
              margin-top 34px
    #info-b3
      min-width 1200px
      height 800px
      background url('../../../assets/web/3s-info-b3.jpg') no-repeat center
      background-size auto 100%
      .ww
        padding-top 103px
        margin-left 368px
        text-align left
        .p2
          margin-top 32px
        .p3
          margin-top 25px
        .p4
          margin-left -200px
          margin-top 152px
          .item
            img
              width 429px
              height 315px
    #info-b4
      min-width 1200px
      height 800px
      background url('../../../assets/web/3s-info-b4.jpg') no-repeat center
      background-size auto 100%
      .ww
        padding-top 151px
        margin-left 354px
        text-align left
        .p2
          margin-top 31px
        .p3
          margin-top 25px

    #info-b5
      min-width 1200px
      height 800px
      background url('../../../assets/web/3s-info-b5.jpg') no-repeat center
      background-size auto 100%
      .ww
        padding-top 138px
        margin-left 434px
        text-align left
        .p0, .p1, .p2, .p3, .p4
          color #fff
        .p2
          margin-top 32px
        .p3
          margin-top 24px
.is-mobile
  .robot3s
    #info-b1, #info-b2, #info-b3, #info-b4, #info-b5, #info-b6, #info-b7, #info-b8
      width 100%
      min-width inherit
      height r(1100)
    #info-b1
      .bg-mask
        background-image url('../../../assets/mobile/3s-info-b1.png')
      .ww
        display block
        .left
          display flex
          flex-direction column
          text-align center
          margin-left r(0)
          margin-top r(100)
          .p2
            margin-top r(16)
          .p3
            margin-top r(16)
        .right
          display flex
          flex-direction column
          margin-top r(40)
          margin-left r(400)
          .p4
            font-size r(20)
            display flex
            align-items center
            padding-bottom r(13)
            img
              margin-right r(10)
              width r(15)
              height r(15)
    #info-b2
      background-image url('../../../assets/mobile/3s-info-b2.png')
      .ww
        text-align center
        padding-top r(118)
        margin-left r(0)
        .p0 
          color #414141
        .p2
          margin-top r(10)
          color #414141
        .p3
          margin-top r(10)
          color #616161;
        .p4
          margin-top r(150)
          margin-left r(-250)
          .item 
            display block
            margin-top r(45)
            img
              width r(170)
              height r(130)
            span 
              font-size r(10)
              margin-top r(10)
    #info-b3
      background-image url('../../../assets/mobile/3s-info-b3.png')
      .ww
        text-align center
        padding-top r(150)
        margin-left r(0)
        .p0 
          color #414141
        .p2
          margin-top r(25)
          color #414141;
        .p3
          margin-top r(15)
          color #444;
        .p4 
          margin-top r(270)
          margin-left r(-300)
          .item
            img 
              width r(340)
              height r(250)
    #info-b4
      background-image url('../../../assets/mobile/3s-info-b4.png')
      .ww
        text-align center
        padding-top r(40)
        margin-left r(0)
        .p0 
          color #eee
        .p1
          color #fff
        .p2
          margin-top r(20)
          color #eee
        .p3
          margin-top r(15)
          color #ddd
    #info-b5
      background-image url('../../../assets/mobile/3s-info-b5.png')
      .ww
        text-align center
        padding-top r(100)
        margin-left r(0)
        .p0, .p1 
          color #000
        .p2
          margin-top r(26)
          color #414141
        .p3
          margin-top r(20)
          color #616161;
  .robot-info
    .ww
      .p1
        font-size 20px
        color #181616
      .p0
        font-size 12px
        color #414141
      .p2
        font-size 12px
        color #414141
      .p3
        font-size 10px
        color #616161
      .p4
        font-size 7px
        color #616161
</style>



// WEBPACK FOOTER //
// src/views/robot/3s/info.vue